export enum VerificationStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REJECTED= 'rejected',
}
